module.exports = __webpack_public_path__ + "img/diferencia-icon.bd23e947.svg";